export const siteSettings = {
  name: "ProTradingFXHub",
  link: "https://protradinghub.net",
  email: "support@protradinghub.net",
  appLink: "https://app.protradinghub.net",
};
